// src/UIElements/Logs/Logs.js
import { LogLogic } from './logLogic';
import './logs.css';


const Logs = () => {
  const {
    logs,
    currentPage,
    totalPages,
    handlePageChange,
    handlePageSizeChange,
    isPageSizeEnabled,
    pageSize,    
    startEntry,
    endEntry,
    totalRecords
  } = LogLogic();

  const trimLongWords = (text, maxLen = 40) =>
    text
      .split(' ')
      .map(word => (word.length > maxLen ? word.slice(0, maxLen) + '...' : word))
      .join(' ');

  return (
    <div className="main-content">
      <div className="p-3 mb-0 mt-1 custom-bg-white rounded">
        <div className="d-flex justify-content-between align-items-center">
          <span className="m-0 title">Logs</span>
        </div>
      </div>

      <div className="mt-3">

        {totalPages > 0 && (
          <div className='pagination-logs-end'>
            <div className="pagination-wrapper-logs">
              <span className="showing-text">
                Showing {startEntry} to {endEntry} of {totalRecords} entries
              </span>
              <span>Show</span>
              <select
                className="form-select"
                value={pageSize}
                disabled={!isPageSizeEnabled}
                onChange={(e) => handlePageSizeChange(e.target.value)}
              >
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>

              <ul className="pagination-req">
                <li>
                  <button
                    className="page-btn-req"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    &lt;
                  </button>
                </li>
                <li>
                  <button className="page-btn-req page-btn-active">{currentPage}</button>
                </li>
                <li>
                  <button
                    className="page-btn-req"
                    disabled={currentPage === totalPages || logs.length === 0}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    &gt;
                  </button>
                </li>
              </ul>
            </div>
          </div>

        )}
      </div>
      <div className="table-content-logs mt-3">
        <table className="table logs-table">
          <thead className="thead-dark">
            <tr>
              <th>SL.NO</th>
              <th>Description</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * pageSize + index + 1}</td>
                  <td>{trimLongWords(log.description)}</td>
                  <td>{new Date(log.addedTimeStamp).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">No logs available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Logs;
